<template>
	<div  class="report-view">
        <CRow>
            <CCol md=9 class="pr-0">
                <CCard class="mb-2">
                    <CCardHeader  class="pt-1 pb-1">
                        <h4>Danh sách nội dung công khai</h4>
                    </CCardHeader>
                    <CCardBody  class="pt-1 pb-1">
                        <CRow class="mb-2">
                            <CCol md="4">
                                <CInput v-model="inputReportName" label="Tên báo cáo"/>
                            </CCol>
                            <CCol md="4">
                                <CInput
                                    v-model="inputCircularsTemplateNo"
                                    label="Biểu mẫu của thông tư"
                                />
                            </CCol>
                            <CCol md="4">
                                <CInput
                                    v-model="inputCircularsNo"
                                    label="Số thông tư áp dụng"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mb-2">
                            <CCol md="4">
                                <CSelect
                                    :value.sync="inputCate"
                                    label="Danh mục"
                                    :options="listSearchCate"
                                />
                            </CCol>
                            <CCol md="2">
                                <CInput
                                    v-model="inputReportYear"
                                    type="number"
                                    label="Năm"
                                />
                            </CCol>
                            <CCol sm="2">
                              <CSelect
                                    label="Kỳ báo cáo"
                                    :options="listPeriod"
                                    :value.sync="inputPeriod"
                                    @change="periodChange"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :class="inputPeriod != 4 && inputPeriod != 5 && inputPeriod != -1 ? 'visible' : 'invisible'"
                                    label="Loại kỳ báo cáo"
                                    :options="listPeriodDetail"
                                    :value.sync="inputPeriodDetail"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mb-2 center">
                            <div class="center">
                                <vs-button square @click="getData" class="m-auto custom_btn_search"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
                            </div>
                            <div class="center">
                                <vs-button square @click="exportXml" class="m-auto"><i class='bx bxs-file-export'></i>&nbsp;Xuất XML</vs-button>
                            </div>
                           
                        </CRow>
                    </CCardBody>
                </CCard>
                <CCard>
                    <vue-good-table
                        :columns="columns"
                        :rows="tableData"
                        styleClass="vgt-table bordered striped"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdownEnabled: false,
                            nextLabel: 'Trang sau',
                            prevLabel: 'Trang trước',
                            ofLabel: 'của',
                        }"
                        :sort-options="{
                            enabled:false
                        }"
                        :line-numbers="true"
                    >
                        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">Không có dữ liệu</div>
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field === 'report_name'">
                                <CLink :to="'/budgetreport/detailbudget/' + props.row.id">{{props.row.report_name}}</CLink>
                            </div>
                            <div v-else-if="props.column.field === 'status'">
                                <span v-if="props.row.status === 0" class="badge badge-danger">
                                    Không sử dụng
                                </span>
                                <span v-else-if="props.row.status === 1" class="badge badge-primary">
                                    Sử dụng
                                </span>
                                <span v-if="props.row.status === 2" class="badge badge-success">
                                    Công khai
                                </span>
                            </div>
                            <div v-else-if="props.column.field === 'file_link'" class="center">
                                <vs-tooltip color="square">
                                    <vs-button transparent @click="displayFile(props.row.list_file)" :hidden="props.row.list_file.length <= 0"  square  circle icon><i class='bx bxs-file'></i></vs-button>
                                    <template #tooltip>
                                        Xem file đính kèm
                                    </template>
                                </vs-tooltip>
                            </div>
                        </template>
                    </vue-good-table>
                </CCard>
            </CCol>
            <CCol md=3>
                <CCard>
                    <CCardHeader  class="pt-1 pb-1">
                        <h4>Danh mục</h4>
                    </CCardHeader>
                    <CCardBody class="pt-1 pb-1">
                        <div v-for="currentCate in listCate.filter(cate => cate.pid === null)" :key="currentCate.value">
                            <list-category :currentCate="currentCate" :listCate="listCate"></list-category>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <!-- show list file -->
		<vs-dialog prevent-close width="650px" v-model="state.dialog.files">
			<ListFile :file_data="this.file_data"/>
		</vs-dialog>
	</div>
</template>

<script>
	import { VueGoodTable } from "vue-good-table";
    import { mapState, mapActions } from "vuex";
	import ClientFactory from "@/api/ClientFactory";
    import ListFile from "../../../components/files/ListFile"
	const api = ClientFactory.get("budgetreport");
	const apiDropdown = ClientFactory.get("dropdowns");
    import listCategory from "@/components/budgetreport/ListCategory";

	export default {
		components: {
			VueGoodTable,
            listCategory,
            ListFile
		},
		data() {
			return {
                inputReportYear: new Date().getFullYear(),
				inputReportName: "",
				inputCircularsTemplateNo: "",
				inputCircularsNo: "",
				inputCate: "",
				listSearchCate: [{
                    value: -1,
                    label: "Tất cả"
                }],
                listCate: [],
				columns: [
					{
						label: "Tên báo cáo",
						field: "report_name",
						thClass: "text-center",
					},
					{
						label: "Năm báo cáo",
						type: "number",
						field: "report_year",
						thClass: "text-center",
                        tdClass: "text-center",
					},
                    {
						label: "Biểu mẫu",
						field: "circulars_template_no",
						thClass: "text-center",
                        tdClass: "text-center",
					},
					{
						label: "Số quyết định/VB Công bố",
						field: "document_no",
						thClass: "text-center",
					},
					{
						label: "Ngày công bố",
						field: "publish_date",
						thClass: "text-center",
                        tdClass: "text-center",
					},
                    {
						label: "Đường dẫn toàn văn",
						field: "file_link",
						thClass: "text-center",
					},
				],
                tableData:[],
                file_data:[],
                state: {
					dialog: {
						files:false,
					},
				},
                inputPeriod: -1,
                inputPeriodDetail: "",
                listPeriodDetail: [],
			};
		},
		computed: {
			 ...mapState("auth", ["AppActiveUser"]),
			listPeriod() {
				return [
					{
						label: "Tất cả",
						value: -1,
					},
					{
						label: "Năm",
						value: 4,
					},
					{
						label: "Nửa năm",
						value: 3,
					},
					{
						label: "Tháng",
						value: 1,
					},
					{
						label: "Quý",
						value: 2,
					},
					{
						label: "9 tháng",
						value: 5,
					},
				]
			},
			listMonth() {
				return [
                    {
						label: "Tất cả",
						value: -1,
					},
					{
						label: "Tháng 1",
						value: 1,
					},
					{
						label: "Tháng 2",
						value: 2,
					},
					{
						label: "Tháng 3",
						value: 3,
					},
					{
						label: "Tháng 4",
						value: 4,
					},
					{
						label: "Tháng 5",
						value: 5,
					},
					{
						label: "Tháng 6",
						value: 6,
					},
					{
						label: "Tháng 7",
						value: 7,
					},
					{
						label: "Tháng 8",
						value: 8,
					},
					{
						label: "Tháng 9",
						value: 9,
					},
					{
						label: "Tháng 10",
						value: 10,
					},
					{
						label: "Tháng 11",
						value: 11,
					},
					{
						label: "Tháng 12",
						value: 12,
					},
				]
			},
			listQuarter() {
				return [
                    {
						label: "Tất cả",
						value: -1,
					},
					{
						label: "Quý 1",
						value: 1,
					},
					{
						label: "Quý 2",
						value: 2,
					},
					{
						label: "Quý 3",
						value: 3,
					},
					{
						label: "Quý 4",
						value: 4,
					},
				]
			},
			listHalfYear() {
				return [
                    {
						label: "Tất cả",
						value: -1,
					},
					{
						label: "6 tháng đầu năm",
						value: 1,
					},
					{
						label: "6 tháng cuối năm",
						value: 2,
					},
				]
			},
		},
		methods: {
            ...mapActions("ui", ["loading", "closeLoading", "notify"]),
            periodChange() {
				if (this.inputPeriod == 1) {
					this.listPeriodDetail = this.listMonth;
				} else if (this.inputPeriod == 2)
					this.listPeriodDetail = this.listQuarter;
				else if (this.inputPeriod == 3)
					this.listPeriodDetail = this.listHalfYear;
				else {
                    this.listPeriodDetail = [{ value: -1, label: "" }];
                    this.inputPeriodDetail = -1;
                } 
			},
			async getData() {
                this.tableData  = [];
				this.loading(this.$vs);
                // Chỉ filter các báo cáo ở trạng thái công khai: Trạng thái: 0 - không sử dụng, 1 - sử dụng, 2 - công khai
                // const {data} =  await api.searchReport(this.inputReportName, this.inputCircularsTemplateNo, this.inputCircularsNo, this.inputCate, "",
                //     2, "", "", this.inputReportYear, -1, -1);
                const {data} =  await api.searchReport(this.inputReportName, this.inputCircularsTemplateNo, this.inputCircularsNo, this.inputCate, "",
                    2, this.inputPeriod, this.inputPeriodDetail, this.inputReportYear, -1, -1);
                this.checkResponseData(data);
				this.closeLoading();
            },
            async exportXml() {
                this.loading(this.$vs);
				const filter = {
					report_name: this.inputReportName,
					circulars_template_no: this.inputCircularsTemplateNo,
					circulars_no: this.inputCircularsNo,
					cate_id: this.inputCate,
					report_type_id: this.inputReportType,
					period_type: this.inputPeriod,
					period_value: this.inputPeriodDetail,
					report_year: this.inputReportYear,
                    status: 2 // Trạng thái: 0 - không sử dụng, 1 - sử dụng, 2 - công khai
				}
                await api.getXml(filter);
                this.closeLoading();
            },
            checkResponseData(data) {
				if(data.status == "success")
				{ 
					if(data.data){
					this.tableData  = data.data;
					}
					else
					this.tableData  = [];
				}else{
					if(data.message != "Xin lỗi, không có dữ liệu"){
						this.notify({
							error:true,
							title: "Thông báo",
							text: data.message
						});
					}
				}
			},
            displayFile(files){
				//console.log(files);
				let arrFile = files.split('||');
				let data =[];

				for (let index = 0; index < arrFile.length; index++) {
					let file = arrFile[index];
					data[index]={
						file_name:file.split('|')[0],
						file_url:file.split('|')[1]
					}
				}
				this.file_data = data;
				// //show dialog
				 this.state.dialog.files = true;
			},
		},
        async created() {
            if (this.$route.query.cateId != undefined)
                this.inputCate = this.$route.query.cateId;
            this.loading(this.$vs);
            this.listCate = await apiDropdown.getItemsTree('BUDGET_REPORT_CATE');
            for (var i=0; i<this.listCate.length; i++){
                this.listSearchCate.push(this.listCate[i]);
            }
            this.closeLoading();
			await this.getData();
		},
        mounted(){
            this.$root.$on('ReportViewerChangeCategory', (cateId) => {
                this.inputCate = cateId;
                this.getData();
            });
        },
		destroyed() {
			this.closeLoading();
		},
	};
</script>

<style lang="scss">
    .report-view{
      table.vgt-table td {
        vertical-align: inherit;
        color: black !important;
        font-size: 14.5px;
        //padding: 0.3rem !important;
        padding: 0em .75em .0em .75em;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
    }
    
</style>